import { lloFetch } from '../../../helpers/lloFetch';
import trans from '../../../helpers/trans';
import { FetchResult, FetchResultType } from '../../FetchResult';
import { OccupationResource } from './Occupations';

export const getCompetentNLOccupationsApiCall = async (query: string): Promise<FetchResult<OccupationResource[], string>> => {
    try {
        const requestConfig = new URLSearchParams({
            searchTerm: query,
            pageSize: '10',
            page: '1',
        }).toString();

        const occupationsResponse = await lloFetch(`/api/competentNLOccupation/Search?${requestConfig}`);

        if (!occupationsResponse.ok) {
            return {
                status: occupationsResponse.status,
                type: FetchResultType.Error,
                error: trans('errors.unknownError'),
            };
        }

        const occupationsData = await occupationsResponse.json();

        return {
            status: occupationsResponse.status,
            type: FetchResultType.Success,
            data: occupationsData.data as OccupationResource[],
        };
    } catch (error) {
        console.error('[getCompetentNLOccupationsApiCall]', error);

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        };
    }
};

export const getCompetentNLOccupationApiCall = async (id: string): Promise<FetchResult<OccupationResource, string>> => {
    try {
        const occupationResponse = await lloFetch(`/api/competentNLOccupation/${id}`);

        if (!occupationResponse.ok) {
            return {
                status: occupationResponse.status,
                type: FetchResultType.Error,
                error: trans('errors.unknownError'),
            };
        }

        const occupationData = await occupationResponse.json();

        return {
            status: occupationResponse.status,
            type: FetchResultType.Success,
            data: occupationData as OccupationResource,
        };
    } catch (error) {
        console.error('[getCompetentNLOccupationApiCall]', error);

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        };
    }
};
